import {
  CheckCircle as CheckIcon,
  Error as ErrorIcon
} from "@mui/icons-material";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bankingService } from "../../services/bankingService";
import { t } from "../../translations";
import { createLogger } from "../../utils/logger";
import { openNotificationWithIcon } from "./notification-bar";

const logger = createLogger("StripeBankingComplete");

const StripeBankingComplete = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const lang = useSelector((state) => state.lang);

  useEffect(() => {
    verifySetup();
  }, []);

  const verifySetup = async () => {
    try {
      const response = await bankingService.verifyAccount(
        user._id,
        user.refresh_token
      );

      if (response.status === "active" && response.payouts_enabled) {
        setSuccess(true);
        openNotificationWithIcon("success", t("banking.setup_complete", lang));
      } else {
        setSuccess(false);
        openNotificationWithIcon(
          "warning",
          t("banking.setup_incomplete", lang)
        );
      }
    } catch (error) {
      logger.error("Failed to verify setup:", error);
      setSuccess(false);
      openNotificationWithIcon(
        "error",
        t("errors.failed_to_verify_setup", lang)
      );
    } finally {
      setLoading(false);
    }
  };

  const handleContinue = () => {
    history.push("/chef/iam-a-chef/home");
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        textAlign="center"
        p={4}
      >
        <CircularProgress size={60} sx={{ mb: 3 }} />
        <Typography variant="h6">
          {t("banking.verifying_setup", lang)}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      textAlign="center"
      p={4}
    >
      {success ? (
        <CheckIcon color="success" sx={{ fontSize: 80, mb: 3 }} />
      ) : (
        <ErrorIcon color="error" sx={{ fontSize: 80, mb: 3 }} />
      )}

      <Typography variant="h4" gutterBottom>
        {success
          ? t("banking.setup_success_title", lang)
          : t("banking.setup_incomplete_title", lang)}
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {success
          ? t("banking.setup_success_message", lang)
          : t("banking.setup_incomplete_message", lang)}
      </Typography>

      <Button
        variant="contained"
        color={success ? "primary" : "error"}
        onClick={handleContinue}
        size="large"
      >
        {success
          ? t("banking.continue_to_dashboard", lang)
          : t("banking.return_to_dashboard", lang)}
      </Button>
    </Box>
  );
};

export default StripeBankingComplete;
